/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { Denotation } from './Denotation';
import {
    DenotationFromJSON,
    DenotationFromJSONTyped,
    DenotationToJSON,
} from './Denotation';
import type { EntityHierarchy } from './EntityHierarchy';
import {
    EntityHierarchyFromJSON,
    EntityHierarchyFromJSONTyped,
    EntityHierarchyToJSON,
} from './EntityHierarchy';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';
import type { LightTable } from './LightTable';
import {
    LightTableFromJSON,
    LightTableFromJSONTyped,
    LightTableToJSON,
} from './LightTable';
import type { Meta } from './Meta';
import {
    MetaFromJSON,
    MetaFromJSONTyped,
    MetaToJSON,
} from './Meta';
import type { PlasmidView } from './PlasmidView';
import {
    PlasmidViewFromJSON,
    PlasmidViewFromJSONTyped,
    PlasmidViewToJSON,
} from './PlasmidView';
import type { SectionTypeConstants } from './SectionTypeConstants';
import {
    SectionTypeConstantsFromJSON,
    SectionTypeConstantsFromJSONTyped,
    SectionTypeConstantsToJSON,
} from './SectionTypeConstants';
import type { Table } from './Table';
import {
    TableFromJSON,
    TableFromJSONTyped,
    TableToJSON,
} from './Table';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * 
 * @export
 * @interface Section
 */
export interface Section {
    /**
     * 
     * @type {SectionTypeConstants}
     * @memberof Section
     */
    type: SectionTypeConstants;
    /**
     * 
     * @type {IconRef}
     * @memberof Section
     */
    icon?: IconRef;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    label?: string;
    /**
     * Optional index (0-based) of active sub section in this tab [used by: Tab]
     * @type {number}
     * @memberof Section
     */
    activeIndex?: number;
    /**
     * Optional list of commands (typically rendered as buttons)
     * @type {Array<Command>}
     * @memberof Section
     */
    commands: Array<Command>;
    /**
     * 
     * @type {EntityHierarchy}
     * @memberof Section
     */
    entityHierarchy?: EntityHierarchy;
    /**
     * 
     * @type {Command}
     * @memberof Section
     */
    fetchSectionCommand?: Command;
    /**
     * 
     * @type {Denotation}
     * @memberof Section
     */
    footerDenotation?: Denotation;
    /**
     * Optional footer note, possibly with line breaks
     * @type {string}
     * @memberof Section
     */
    footerNote?: string;
    /**
     * 
     * @type {Denotation}
     * @memberof Section
     */
    headerDenotation?: Denotation;
    /**
     * Optional header note, possibly with line breaks
     * @type {string}
     * @memberof Section
     */
    headerNote?: string;
    /**
     * 
     * @type {LightTable}
     * @memberof Section
     */
    lightTable?: LightTable;
    /**
     * 
     * @type {Meta}
     * @memberof Section
     */
    metaInfo?: Meta;
    /**
     * 
     * @type {PlasmidView}
     * @memberof Section
     */
    plasmidView?: PlasmidView;
    /**
     * Optional list of property values [used by: PropertiesListing, Tracking]
     * @type {Array<Value>}
     * @memberof Section
     */
    propertyValues: Array<Value>;
    /**
     * Optional list of sub sections [used by: Tab, Dynamic]
     * @type {Array<Section>}
     * @memberof Section
     */
    sections: Array<Section>;
    /**
     * 
     * @type {Table}
     * @memberof Section
     */
    table?: Table;
    /**
     * 
     * @type {Command}
     * @memberof Section
     */
    toggleExpanded?: Command;
    /**
     * Whether or not a section is expanded
     * @type {boolean}
     * @memberof Section
     */
    expanded: boolean;
    /**
     * Whether or not the section header is to be shown
     * @type {boolean}
     * @memberof Section
     */
    headless?: boolean;
}

/**
 * Check if a given object implements the Section interface.
 */
export function instanceOfSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "commands" in value;
    isInstance = isInstance && "propertyValues" in value;
    isInstance = isInstance && "sections" in value;
    isInstance = isInstance && "expanded" in value;

    return isInstance;
}

export function SectionFromJSON(json: any): Section {
    return SectionFromJSONTyped(json, false);
}

export function SectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Section {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': SectionTypeConstantsFromJSON(json['type']),
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'activeIndex': !exists(json, 'activeIndex') ? undefined : json['activeIndex'],
        'commands': ((json['commands'] as Array<any>).map(CommandFromJSON)),
        'entityHierarchy': !exists(json, 'entityHierarchy') ? undefined : EntityHierarchyFromJSON(json['entityHierarchy']),
        'fetchSectionCommand': !exists(json, 'fetchSectionCommand') ? undefined : CommandFromJSON(json['fetchSectionCommand']),
        'footerDenotation': !exists(json, 'footerDenotation') ? undefined : DenotationFromJSON(json['footerDenotation']),
        'footerNote': !exists(json, 'footerNote') ? undefined : json['footerNote'],
        'headerDenotation': !exists(json, 'headerDenotation') ? undefined : DenotationFromJSON(json['headerDenotation']),
        'headerNote': !exists(json, 'headerNote') ? undefined : json['headerNote'],
        'lightTable': !exists(json, 'lightTable') ? undefined : LightTableFromJSON(json['lightTable']),
        'metaInfo': !exists(json, 'metaInfo') ? undefined : MetaFromJSON(json['metaInfo']),
        'plasmidView': !exists(json, 'plasmidView') ? undefined : PlasmidViewFromJSON(json['plasmidView']),
        'propertyValues': ((json['propertyValues'] as Array<any>).map(ValueFromJSON)),
        'sections': ((json['sections'] as Array<any>).map(SectionFromJSON)),
        'table': !exists(json, 'table') ? undefined : TableFromJSON(json['table']),
        'toggleExpanded': !exists(json, 'toggleExpanded') ? undefined : CommandFromJSON(json['toggleExpanded']),
        'expanded': json['expanded'],
        'headless': !exists(json, 'headless') ? undefined : json['headless'],
    };
}

export function SectionToJSON(value?: Section | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': SectionTypeConstantsToJSON(value.type),
        'icon': IconRefToJSON(value.icon),
        'id': value.id,
        'label': value.label,
        'activeIndex': value.activeIndex,
        'commands': ((value.commands as Array<any>).map(CommandToJSON)),
        'entityHierarchy': EntityHierarchyToJSON(value.entityHierarchy),
        'fetchSectionCommand': CommandToJSON(value.fetchSectionCommand),
        'footerDenotation': DenotationToJSON(value.footerDenotation),
        'footerNote': value.footerNote,
        'headerDenotation': DenotationToJSON(value.headerDenotation),
        'headerNote': value.headerNote,
        'lightTable': LightTableToJSON(value.lightTable),
        'metaInfo': MetaToJSON(value.metaInfo),
        'plasmidView': PlasmidViewToJSON(value.plasmidView),
        'propertyValues': ((value.propertyValues as Array<any>).map(ValueToJSON)),
        'sections': ((value.sections as Array<any>).map(SectionToJSON)),
        'table': TableToJSON(value.table),
        'toggleExpanded': CommandToJSON(value.toggleExpanded),
        'expanded': value.expanded,
        'headless': value.headless,
    };
}

